module.exports = __webpack_public_path__ + "static/media/postgres.efd97af0.png";